<template>
  <div class="filter-item">
    <div
      class="filterItem-content--fold"
    >
      <slot>
        <el-checkbox-group v-model="checkList" size="medium" :border="false">
          <el-checkbox-button
            :label="index"
            v-for="(item, index) in cpu_list"
            :key="index"
            @change="selectItem(item)"
            class="content-item"
          >
            {{ item[labelKey] }}
          </el-checkbox-button>
        </el-checkbox-group>
        <slot name="append"></slot>
      </slot>
    </div>
    <!-- <div
      v-if="fold"
      class="filterItem-right"
      :class="{ 'filterItem-right--unfold': unfold }"
      @click="toggleFold"
    >
      <span>{{ unfold ? "收起" : "更多" }}</span>
      <i class="el-icon-caret-bottom icon"></i>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "FilterCheckBox",
  props: {
    value: {},
    label: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default: () => [],
    },
    checkLists: {
      type: Array,
      default: () => [],
    },
    // 是否需要不限
    needAll: {
      type: Boolean,
      default: true,
    },
    valueKey: {
      type: String,
      default: "value",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    // 是否开启展开折叠
    fold: {
      type: Boolean,
      default: false,
    },
    type:{
      type: String,
      default: '0',
    }
  },
  data() {
    return {
      unfold: false, // 展开状态位
      checkList: [],
    };
  },
  computed: {
    cpu_value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    cpu_list() {
      if (this.needAll) {
        return [
          {
            [this.valueKey]: "",
            [this.labelKey]: "不限",
          },
        ].concat(this.list);
      } else {
        return this.list;
      }
    },
    cpu_isActive() {
      return function (item) {
        return item[this.valueKey] == this.value;
      };
    },
  },
  created(){
    // if(this.type == '1'){
    //   let item = {};
    //   item.label = '不限';
    //   this.selectItem(item);
    // }
    this.checkList = this.checkLists
  },
  methods: {
    /**
     * @description: 选择子项
     * @param {Object} item 子项
     */
    selectItem(item) {
      let checkvalue = [];
      if (this.checkList.length > 0) {
        this.checkList.forEach((item) => {
          checkvalue.push(this.cpu_list[item][this.valueKey]);
        });
          checkvalue = checkvalue.join();
      }
      else{
        checkvalue=''
      }
      this.$nextTick(() => {
        this.$parent.$emit("change", this.$attrs.lable, checkvalue);
      });
    },
    cleanBoxList(){
      this.checkList = []
    },
    /**
     * @description: 切换展开折叠状态
     */
    toggleFold() {
      this.unfold = !this.unfold;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/com/theme.scss";

$itemHeight: 60px;
::v-deep .el-checkbox-button--medium .el-checkbox-button__inner {
    border: 0.0625rem solid #409EFF;
    border-radius: 0.25rem;
    padding: 10px;
    margin: auto 5px;
    //color:#409EFF;
}

::v-deep .el-checkbox-button--medium .el-checkbox-button__inner:hover {
    border: 0.0625rem solid #409EFF;
    border-radius: 0.25rem;
    padding: 10px;
    margin: auto 5px;
    color:#FFF;
    background-color: #409EFF;
}
.filter-item {
  display: -webkit-flex;
  display: flex;
  padding-top: 5px;
  padding-bottom: 5px;
}
.filterItem-label,
.content-item,
.filterItem-right {
  height: $itemHeight;
  line-height: $itemHeight;
  span,
  i{
    color: #409eff;
  }
}
.filterItem-label {
  min-width: 80px;
  color: #000000;
}
.filterItem-content {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 5px;
  padding-left: 20px;
  overflow: hidden;

  .content-item {
    display: inline-block;
    // padding-right: 10px;
    // padding-left: 10px;
    cursor: pointer;

    &:hover {
      color: $col-theme;
    }
    &.content-item--active {
      border-radius: 4px;
      color: #ffffff;
      background-color: $col-theme;
    }
  }
  &.filterItem-content--fold {
    height: $itemHeight;
  }
}
.filterItem-right {
  color: #999999;
  margin-left: 20px;
  cursor: pointer;

  .icon {
    margin-left: 5px;
    -webkit-transition: transform 0.2s linear 0s;
    -moz-transition: transform 0.2s linear 0s;
    -o-transition: transform 0.2s linear 0s;
    transition: transform 0.2s linear 0s;
  }
  &.filterItem-right--unfold .icon {
    transform: rotate(180deg);
  }
}
</style>
